// Group II. 時態與體 Tense and Aspect
// Based on "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group2Data = {
  id: "group_2",
  title: {
    tc: "時態與體",
    sc: "时态与体",
    en: "Tense and Aspect"
  },
  subtitle: {
    tc: "Tense and Aspect",
    sc: "Tense and Aspect",
    en: "Tense and Aspect"
  },
  icon: "⏰",
  difficulty: "beginner",
  color: "from-green-500 to-green-600",
  topics: [
    {
      id: "present_simple",
      title: {
        tc: "現在簡單式",
        sc: "现在简单式",
        en: "Present Simple"
      },
      description: {
        tc: "學習現在式的基本用法和結構",
        sc: "学习现在式的基本用法和结构",
        en: "Learn the basic usage and structure of the present tense"
      },
      icon: "🕐",
      difficulty: "beginner",
      examples: [
        {
          id: "present_simple_1",
          sentence: "She plays the piano every day.",
          analysis: "She (S) plays (V) the piano (O) every day (M).",
          translation: {
            tc: "她每天彈鋼琴。",
            sc: "她每天弹钢琴。",
            en: "She plays the piano every day."
          }
        },
        {
          id: "present_simple_2",
          sentence: "Water boils at 100°C.",
          analysis: "Water (S) boils (V) at 100°C (M).",
          translation: {
            tc: "水在100°C沸騰。",
            sc: "水在100°C沸腾。",
            en: "Water boils at 100°C."
          }
        },
        {
          id: "present_simple_3",
          sentence: "I work in finance.",
          analysis: "I (S) work (V) in finance (M).",
          translation: {
            tc: "我在金融業工作。",
            sc: "我在金融业工作。",
            en: "I work in finance."
          }
        },
        {
          id: "present_simple_4",
          sentence: "They live nearby.",
          analysis: "They (S) live (V) nearby (M).",
          translation: {
            tc: "他們住在附近。",
            sc: "他们住在附近。",
            en: "They live nearby."
          }
        },
        {
          id: "present_simple_5",
          sentence: "The store opens at ten.",
          analysis: "The store (S) opens (V) at ten (M).",
          translation: {
            tc: "商店在十點開門。",
            sc: "商店在十点开门。",
            en: "The store opens at ten."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：習慣/事實；三單動詞加 s。",
        sc: "要点：习惯/事实；三单动词加 s。",
        en: "Key points: Habits/facts; third person singular verbs add s."
      }
    },
    {
      id: "present_continuous",
      title: {
        tc: "現在進行式",
        sc: "现在进行式",
        en: "Present Continuous"
      },
      description: {
        tc: "學習現在進行式的構成和用法",
        sc: "学习现在进行式的构成和用法",
        en: "Learn the structure and usage of present continuous"
      },
      icon: "🔄",
      difficulty: "beginner",
      examples: [
        {
          id: "present_continuous_1",
          sentence: "They are studying now.",
          analysis: "They (S) are studying (V) now (M).",
          translation: {
            tc: "他們現在正在學習。",
            sc: "他们现在正在学习。",
            en: "They are studying now."
          }
        },
        {
          id: "present_continuous_2",
          sentence: "I am working from home today.",
          analysis: "I (S) am working (V) from home (M) today (M).",
          translation: {
            tc: "我今天在家工作。",
            sc: "我今天在家工作。",
            en: "I am working from home today."
          }
        },
        {
          id: "present_continuous_3",
          sentence: "She is cooking dinner.",
          analysis: "She (S) is cooking (V) dinner (O).",
          translation: {
            tc: "她正在做晚餐。",
            sc: "她正在做晚餐。",
            en: "She is cooking dinner."
          }
        },
        {
          id: "present_continuous_4",
          sentence: "We are meeting at noon.",
          analysis: "We (S) are meeting (V) at noon (M).",
          translation: {
            tc: "我們中午見面。",
            sc: "我们中午见面。",
            en: "We are meeting at noon."
          }
        },
        {
          id: "present_continuous_5",
          sentence: "The kids are playing outside.",
          analysis: "The kids (S) are playing (V) outside (M).",
          translation: {
            tc: "孩子們在外面玩。",
            sc: "孩子们在外面玩。",
            en: "The kids are playing outside."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：be + V-ing；此刻/臨時安排/趨勢描述。",
        sc: "要点：be + V-ing；此刻/临时安排/趋势描述。",
        en: "Key points: be + V-ing; current moment/temporary arrangements/trends."
      }
    },
    {
      id: "past_simple",
      title: {
        tc: "過去簡單式",
        sc: "过去简单式",
        en: "Past Simple"
      },
      description: {
        tc: "學習過去簡單式的構成和用法",
        sc: "学习过去简单式的构成和用法",
        en: "Learn the structure and usage of past simple"
      },
      icon: "📅",
      difficulty: "beginner",
      examples: [
        {
          id: "past_simple_1",
          sentence: "We visited Paris last year.",
          analysis: "We (S) visited (V) Paris (O) last year (M).",
          translation: {
            tc: "我們去年去了巴黎。",
            sc: "我们去年去了巴黎。",
            en: "We visited Paris last year."
          }
        },
        {
          id: "past_simple_2",
          sentence: "She called me yesterday.",
          analysis: "She (S) called (V) me (O) yesterday (M).",
          translation: {
            tc: "她昨天打電話給我。",
            sc: "她昨天打电话给我。",
            en: "She called me yesterday."
          }
        },
        {
          id: "past_simple_3",
          sentence: "The event ended at midnight.",
          analysis: "The event (S) ended (V) at midnight (M).",
          translation: {
            tc: "活動在午夜結束。",
            sc: "活动在午夜结束。",
            en: "The event ended at midnight."
          }
        },
        {
          id: "past_simple_4",
          sentence: "He studied law in college.",
          analysis: "He (S) studied (V) law (O) in college (M).",
          translation: {
            tc: "他在大學讀法律。",
            sc: "他在大学读法律。",
            en: "He studied law in college."
          }
        },
        {
          id: "past_simple_5",
          sentence: "I lost my keys.",
          analysis: "I (S) lost (V) my keys (O).",
          translation: {
            tc: "我丟了鑰匙。",
            sc: "我丢了钥匙。",
            en: "I lost my keys."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：已完成的過去；常伴具體時間標記。",
        sc: "要点：已完成的过去；常伴具体时间标记。",
        en: "Key points: Completed past actions; often with specific time markers."
      }
    },
    {
      id: "past_continuous",
      title: {
        tc: "過去進行式",
        sc: "过去进行式",
        en: "Past Continuous"
      },
      description: {
        tc: "學習過去進行式的構成和用法",
        sc: "学习过去进行式的构成和用法",
        en: "Learn the structure and usage of past continuous"
      },
      icon: "⏳",
      difficulty: "intermediate",
      examples: [
        {
          id: "past_continuous_1",
          sentence: "I was reading when you called.",
          analysis: "I (S) was reading (V) when (conj) [you (S) called (V)] (M).",
          translation: {
            tc: "你打電話時我正在讀書。",
            sc: "你打电话时我正在读书。",
            en: "I was reading when you called."
          }
        },
        {
          id: "past_continuous_2",
          sentence: "They were sleeping at ten.",
          analysis: "They (S) were sleeping (V) at ten (M).",
          translation: {
            tc: "他們十點時在睡覺。",
            sc: "他们十点时在睡觉。",
            en: "They were sleeping at ten."
          }
        },
        {
          id: "past_continuous_3",
          sentence: "She was driving home then.",
          analysis: "She (S) was driving (V) home (M) then (M).",
          translation: {
            tc: "那時她正在開車回家。",
            sc: "那时她正在开车回家。",
            en: "She was driving home then."
          }
        },
        {
          id: "past_continuous_4",
          sentence: "We were having dinner as it started to rain.",
          analysis: "We (S) were having (V) dinner (O) as (conj) [it (S) started (V) to rain (O)] (M).",
          translation: {
            tc: "開始下雨時我們正在吃晚餐。",
            sc: "开始下雨时我们正在吃晚餐。",
            en: "We were having dinner as it started to rain."
          }
        },
        {
          id: "past_continuous_5",
          sentence: "He was working while I was studying.",
          analysis: "He (S) was working (V) while (conj) [I (S) was studying (V)] (M).",
          translation: {
            tc: "我在讀書時他在工作。",
            sc: "我在读书时他在工作。",
            en: "He was working while I was studying."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：背景進行 + 打斷事件；同時進行可用 while。",
        sc: "要点：背景进行 + 打断事件；同时进行可用 while。",
        en: "Key points: Background action + interrupting event; simultaneous actions use while."
      }
    },
    {
      id: "present_perfect",
      title: {
        tc: "現在完成式",
        sc: "现在完成式",
        en: "Present Perfect"
      },
      description: {
        tc: "學習現在完成式的構成和用法",
        sc: "学习现在完成式的构成和用法",
        en: "Learn the structure and usage of present perfect"
      },
      icon: "✅",
      difficulty: "intermediate",
      examples: [
        {
          id: "present_perfect_1",
          sentence: "I have finished my work.",
          analysis: "I (S) have finished (V) my work (O).",
          translation: {
            tc: "我已經完成了工作。",
            sc: "我已经完成了工作。",
            en: "I have finished my work."
          }
        },
        {
          id: "present_perfect_2",
          sentence: "She has visited Japan three times.",
          analysis: "She (S) has visited (V) Japan (O) three times (M).",
          translation: {
            tc: "她去過日本三次。",
            sc: "她去过日本三次。",
            en: "She has visited Japan three times."
          }
        },
        {
          id: "present_perfect_3",
          sentence: "We have known each other for years.",
          analysis: "We (S) have known (V) each other (O) for years (M).",
          translation: {
            tc: "我們認識多年了。",
            sc: "我们认识多年了。",
            en: "We have known each other for years."
          }
        },
        {
          id: "present_perfect_4",
          sentence: "The package has arrived.",
          analysis: "The package (S) has arrived (V).",
          translation: {
            tc: "包裹已經到了。",
            sc: "包裹已经到了。",
            en: "The package has arrived."
          }
        },
        {
          id: "present_perfect_5",
          sentence: "Prices have increased lately.",
          analysis: "Prices (S) have increased (V) lately (M).",
          translation: {
            tc: "最近價格上漲了。",
            sc: "最近价格上涨了。",
            en: "Prices have increased lately."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：經驗/結果/持續（for/since）；與現在相關。",
        sc: "要点：经验/结果/持续（for/since）；与现在相关。",
        en: "Key points: Experience/result/duration (for/since); connected to present."
      }
    },
    {
      id: "present_perfect_continuous",
      title: {
        tc: "現在完成進行式",
        sc: "现在完成进行式",
        en: "Present Perfect Continuous"
      },
      description: {
        tc: "學習現在完成進行式的構成和用法",
        sc: "学习现在完成进行式的构成和用法",
        en: "Learn the structure and usage of present perfect continuous"
      },
      icon: "🔄",
      difficulty: "intermediate",
      examples: [
        {
          id: "present_perfect_continuous_1",
          sentence: "He has been working for three hours.",
          analysis: "He (S) has been working (V) for three hours (M).",
          translation: {
            tc: "他已經工作了三個小時。",
            sc: "他已经工作了三个小时。",
            en: "He has been working for three hours."
          }
        },
        {
          id: "present_perfect_continuous_2",
          sentence: "I have been waiting since noon.",
          analysis: "I (S) have been waiting (V) since noon (M).",
          translation: {
            tc: "我從中午就一直在等。",
            sc: "我从中午就一直在等。",
            en: "I have been waiting since noon."
          }
        },
        {
          id: "present_perfect_continuous_3",
          sentence: "She has been studying English lately.",
          analysis: "She (S) has been studying (V) English (O) lately (M).",
          translation: {
            tc: "她最近一直在學英語。",
            sc: "她最近一直在学英语。",
            en: "She has been studying English lately."
          }
        },
        {
          id: "present_perfect_continuous_4",
          sentence: "They have been building a new bridge.",
          analysis: "They (S) have been building (V) a new bridge (O).",
          translation: {
            tc: "他們一直在建造一座新橋。",
            sc: "他们一直在建造一座新桥。",
            en: "They have been building a new bridge."
          }
        },
        {
          id: "present_perfect_continuous_5",
          sentence: "The market has been changing rapidly.",
          analysis: "The market (S) has been changing (V) rapidly (M).",
          translation: {
            tc: "市場一直在快速變化。",
            sc: "市场一直在快速变化。",
            en: "The market has been changing rapidly."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：動作從過去持續至今，強調過程與持續時間。",
        sc: "要点：动作从过去持续至今，强调过程与持续时间。",
        en: "Key points: Action continuing from past to present, emphasizing process and duration."
      }
    },
    {
      id: "past_perfect",
      title: {
        tc: "過去完成式",
        sc: "过去完成式",
        en: "Past Perfect"
      },
      description: {
        tc: "學習過去完成式的構成和用法",
        sc: "学习过去完成式的构成和用法",
        en: "Learn the structure and usage of past perfect"
      },
      icon: "⏪",
      difficulty: "intermediate",
      examples: [
        {
          id: "past_perfect_1",
          sentence: "She had left before I arrived.",
          analysis: "She (S) had left (V) before (conj) [I (S) arrived (V)] (M).",
          translation: {
            tc: "我到達前她已經離開了。",
            sc: "我到达前她已经离开了。",
            en: "She had left before I arrived."
          }
        },
        {
          id: "past_perfect_2",
          sentence: "I had never seen snow before then.",
          analysis: "I (S) had seen (V-neg) never (M) snow (O) before then (M).",
          translation: {
            tc: "在那之前我從未見過雪。",
            sc: "在那之前我从未见过雪。",
            en: "I had never seen snow before then."
          }
        },
        {
          id: "past_perfect_3",
          sentence: "They had finished by noon.",
          analysis: "They (S) had finished (V) by noon (M).",
          translation: {
            tc: "他們中午前就完成了。",
            sc: "他们中午前就完成了。",
            en: "They had finished by noon."
          }
        },
        {
          id: "past_perfect_4",
          sentence: "He had already eaten when we called.",
          analysis: "He (S) had eaten (V) already (M) when (conj) [we (S) called (V)] (M).",
          translation: {
            tc: "我們打電話時他已經吃過了。",
            sc: "我们打电话时他已经吃过了。",
            en: "He had already eaten when we called."
          }
        },
        {
          id: "past_perfect_5",
          sentence: "The meeting had started by the time she came.",
          analysis: "The meeting (S) had started (V) by the time (conj) [she (S) came (V)] (M).",
          translation: {
            tc: "她來時會議已經開始了。",
            sc: "她来时会议已经开始了。",
            en: "The meeting had started by the time she came."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：先過去；配 before/by the time/already。",
        sc: "要点：先过去；配 before/by the time/already。",
        en: "Key points: Earlier past; used with before/by the time/already."
      }
    },
    {
      id: "future_will",
      title: {
        tc: "未來式 will",
        sc: "未来式 will",
        en: "Future with will"
      },
      description: {
        tc: "學習 will 未來式的構成和用法",
        sc: "学习 will 未来式的构成和用法",
        en: "Learn the structure and usage of future with will"
      },
      icon: "🔮",
      difficulty: "beginner",
      examples: [
        {
          id: "future_will_1",
          sentence: "I will call you later.",
          analysis: "I (S) will call (V) you (O) later (M).",
          translation: {
            tc: "我稍後會打電話給你。",
            sc: "我稍后会打电话给你。",
            en: "I will call you later."
          }
        },
        {
          id: "future_will_2",
          sentence: "She will be there soon.",
          analysis: "She (S) will be (V) there (M).",
          translation: {
            tc: "她很快就會到那裡。",
            sc: "她很快就会到那里。",
            en: "She will be there soon."
          }
        },
        {
          id: "future_will_3",
          sentence: "We will see what happens.",
          analysis: "We (S) will see (V) what (Wh) [happens (V)] (O-clause).",
          translation: {
            tc: "我們會看到發生什麼。",
            sc: "我们会看到发生什么。",
            en: "We will see what happens."
          }
        },
        {
          id: "future_will_4",
          sentence: "It will rain tomorrow.",
          analysis: "It (S) will rain (V) tomorrow (M).",
          translation: {
            tc: "明天會下雨。",
            sc: "明天会下雨。",
            en: "It will rain tomorrow."
          }
        },
        {
          id: "future_will_5",
          sentence: "I'll help if you need me.",
          analysis: "I (S) will help (V) if (conj) [you (S) need (V) me (O)] (M-cond).",
          translation: {
            tc: "如果你需要我，我會幫忙。",
            sc: "如果你需要我，我会帮忙。",
            en: "I'll help if you need me."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：臨時決定/承諾/預測；常與條件句連用。",
        sc: "要点：临时决定/承诺/预测；常与条件句连用。",
        en: "Key points: Spontaneous decisions/promises/predictions; often with conditionals."
      }
    },
    {
      id: "future_going_to",
      title: {
        tc: "be going to 未來式",
        sc: "be going to 未来式",
        en: "Future with be going to"
      },
      description: {
        tc: "學習 be going to 未來式的構成和用法",
        sc: "学习 be going to 未来式的构成和用法",
        en: "Learn the structure and usage of future with be going to"
      },
      icon: "🎯",
      difficulty: "beginner",
      examples: [
        {
          id: "future_going_to_1",
          sentence: "It is going to rain.",
          analysis: "It (S) is going to rain (V).",
          translation: {
            tc: "要下雨了。",
            sc: "要下雨了。",
            en: "It is going to rain."
          }
        },
        {
          id: "future_going_to_2",
          sentence: "We are going to move next month.",
          analysis: "We (S) are going to move (V) next month (M).",
          translation: {
            tc: "我們下個月要搬家。",
            sc: "我们下个月要搬家。",
            en: "We are going to move next month."
          }
        },
        {
          id: "future_going_to_3",
          sentence: "I am going to start a blog.",
          analysis: "I (S) am going to start (V) a blog (O).",
          translation: {
            tc: "我要開始寫部落格。",
            sc: "我要开始写博客。",
            en: "I am going to start a blog."
          }
        },
        {
          id: "future_going_to_4",
          sentence: "They are going to visit us.",
          analysis: "They (S) are going to visit (V) us (O).",
          translation: {
            tc: "他們要來拜訪我們。",
            sc: "他们要来拜访我们。",
            en: "They are going to visit us."
          }
        },
        {
          id: "future_going_to_5",
          sentence: "This is going to be difficult.",
          analysis: "This (S) is going to be (V) difficult (C).",
          translation: {
            tc: "這會很困難。",
            sc: "这会很困难。",
            en: "This is going to be difficult."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：計畫/徵兆性預測；口語常見。",
        sc: "要点：计划/征兆性预测；口语常见。",
        en: "Key points: Plans/evidence-based predictions; common in spoken English."
      }
    }
  ]
};
